import { apiServer } from "../../../api";
import { IBackupTarefaResumo, IBackupArquivo, IBackupArquivoDetalhes } from "../types";

export const CentralBackupsApi = {
  obterTarefas: async (clienteID: string, token: string) => {
    const response = await apiServer<{ items: IBackupTarefaResumo[] }>().get(
      `v2/backups/tarefas/${clienteID}`,
      token
    );
    return response.data;
  },

  obterArquivosTarefa: async (
    tarefaAgendadaID: string,
    token: string,
    params: {
      limit?: number;
      offset?: number;
      q?: string;
      dataInicial?: string;
      dataFinal?: string;
      ordenarPor?: string;
      direcao?: string;
    }
  ) => {
    let url = `v2/backups/tarefas/${tarefaAgendadaID}/arquivos?limit=${params.limit ?? 10}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.dataInicial) {
      url += `&dataInicial=${encodeURIComponent(params.dataInicial)}`;
    }
    if (params.dataFinal) {
      url += `&dataFinal=${encodeURIComponent(params.dataFinal)}`;
    }
    if (params.ordenarPor) {
      url += `&ordenarPor=${encodeURIComponent(params.ordenarPor)}`;
    }
    if (params.direcao) {
      url += `&direcao=${encodeURIComponent(params.direcao)}`;
    }

    const response = await apiServer<{ items: IBackupArquivo[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  },

  pesquisarArquivos: async (
    token: string,
    params: {
      clienteID: string;
      q?: string;
      tarefaAgendadaID?: string;
      dataInicial?: string;
      dataFinal?: string;
      tipo?: string;
      status?: string;
      tamanhoMinimoBytes?: number;
      tamanhoMaximoBytes?: number;
      limit?: number;
      offset?: number;
      ordenarPor?: string;
      direcao?: string;
    }
  ) => {
    let url = `v2/backups/arquivos/pesquisar?clienteID=${params.clienteID}&limit=${params.limit ?? 10}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.tarefaAgendadaID) {
      url += `&tarefaAgendadaID=${params.tarefaAgendadaID}`;
    }
    if (params.dataInicial) {
      url += `&dataInicial=${encodeURIComponent(params.dataInicial)}`;
    }
    if (params.dataFinal) {
      url += `&dataFinal=${encodeURIComponent(params.dataFinal)}`;
    }
    if (params.tipo) {
      url += `&tipo=${params.tipo}`;
    }
    if (params.status) {
      url += `&status=${params.status}`;
    }
    if (params.tamanhoMinimoBytes !== undefined) {
      url += `&tamanhoMinimoBytes=${params.tamanhoMinimoBytes}`;
    }
    if (params.tamanhoMaximoBytes !== undefined) {
      url += `&tamanhoMaximoBytes=${params.tamanhoMaximoBytes}`;
    }
    if (params.ordenarPor) {
      url += `&ordenarPor=${encodeURIComponent(params.ordenarPor)}`;
    }
    if (params.direcao) {
      url += `&direcao=${encodeURIComponent(params.direcao)}`;
    }

    const response = await apiServer<{ items: IBackupArquivo[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  },

  obterDetalhesArquivo: async (arquivoID: string, token: string) => {
    const response = await apiServer<IBackupArquivoDetalhes>().get(
      `v2/backups/arquivos/${arquivoID}/detalhes`,
      token
    );
    return response.data;
  },

  solicitarArquivoDownload: async (arquivoID: string, token: string) => {
    const response = await apiServer<string>().get(
      `arquivo/solicitar-arquivo/${arquivoID}`,
      token
    );
    return response.data;
  }
};
